<template>
  <v-container>
    <v-row dense>
      <v-col
          v-for="header in props.headers"
          :key="header.key"
          cols="12"
          md="6"
      >
        <div v-if="header.canBeFiltered == true || header.canBeFiltered == undefined">
          <component
              v-if="header.filterComponent"
              :is="header.filterComponent"
              v-model="localModel[header.key]"
              :prepend-icon="header.icon"
              v-bind="header.filterProps"
              :disabled="header.disabled"
          />
          <!--MotorTypeSelector v-else-if="header.key == 'type'" :prepend_icon="header.icon" v-model="localModel[header.key]"
                             :disabled="header.disabled"/>
          <IsSafetySelect v-else-if="header.key == 'isSafety'" v-model="localModel[header.key]" :prepent-icon="header.icon"
                          :disabled="header.disabled">
          <StateSelect v-else-if="header.key == 'state'" v-model="localModel[header.key]" :permission="Groups.admin.permission"
                       :prepent-icon="header.icon" :disabled="header.disabled"/-->
          <v-range-slider v-else-if="header.key == 'progress'" v-model="localModel[header.key]" step="1" @mouseenter="rangeHover = true"
                          @mouseleave="rangeHover = false" :thumb-label="rangeHover ? 'always' : false" :prepend-icon="header.icon"
                          :disabled="header.disabled">
            <template #thumb-label="{ modelValue }">
              {{ modelValue }}%
            </template>
          </v-range-slider>
          <v-text-field
              v-else-if="!header.checkbox"
              v-model="localModel[header.key]"
              :label="`${header.title} enthält`"
              :prepend-icon="header.icon"
              clearable
              @keydown.enter="applyFilters"
              :variant="useGlobalSetting().globalTextVariant"
              :disabled="header.disabled"
          />
          <v-switch
              v-else
              v-model="localModel[header.key]"
              base-color="info"
              :color="header.key === 'isSafety' ? 'yellow': 'primary'"
              :label="header.title"
              :prepend-icon="header.icon"
              density="compact"
              hide-details
              inset
              :disabled="header.disabled"
          />
        </div>
      </v-col>

      <!--v-col cols="12" md="6">
        <v-radio-group
            v-model="localSortBy"
            label="Sortierreihenfolge"
            row
        >
          <v-radio label="Aufsteigend" value="asc"/>
          <v-radio label="Absteigend" value="desc"/>
        </v-radio-group>
      </v-col-->
      <v-col cols="12">
        <div class="mb-2">Sortiere nach</div>
        <!--v-model="selectedSortField"
              :color="selectedSortField === header.key ? 'primary' : ''"
              -->
        <v-chip-group column>
          <div v-for="header in headers"
               :key="header.key">
            <v-chip
                v-if="!header.checkbox"
                class="ma-1"
                @click="toggleSortDirection(header.key)"
            >
              {{ header.title }}
              <v-icon v-if="selectedSortField === header.key" end>{{ getSortIcon(header.key) }}</v-icon>
            </v-chip>
          </div>
        </v-chip-group>
      </v-col>
    </v-row>

    <v-row class="mt-4">
      <a
          href="#"
          @click.prevent="openFilterSyntaxDialog()"
          target="_blank"
          rel="noopener"
          class="link-with-icon text-primary"
      >
        <v-icon start class="no-underline">mdi-help-circle-outline</v-icon>
        <span class="underline-text">Filtersyntax</span>
      </a>
      <v-spacer/>
      <v-btn color="btnColor" :variant="useGlobalSetting().globalButtonVariant" @click="applyFilters">
        <v-icon icon="mdi-filter-outline" start/>
        Filter anwenden
      </v-btn>
    </v-row>
  </v-container>
</template>

<script lang="ts" setup>
import {Component, reactive, ref, watch} from 'vue'
import MotorTypeSelector from "@/components/inputs/motorTypeSelector.vue";
import IsSafetySelect from "@/components/inputs/isSafetySelect.vue";
import {openFilterSyntaxDialog, useGlobalSetting} from "@/lib/utils";
import StateSelect from "@/components/inputs/StateSelect.vue";
import {Groups} from "@/types/Order";
import {Header} from "@/lib/types";

const model = defineModel();

const sortBy = defineModel('model2');

const props = defineProps<{
  onClose?: () => void,
  headers?: Header[],
  fetch?: () => void,
}>()

const localModel = ref(JSON.parse(JSON.stringify(model.value)));

const selectedSortField = ref<string>('')
const sortDirectionMap = reactive<Record<string, 'asc' | 'desc'>>({})

const rangeHover = ref<boolean>(false);

selectedSortField.value = sortBy.value[0].key;
sortDirectionMap[selectedSortField.value] = sortBy.value[0].order;

watch(() => model, (newVal) => {
  localModel.value = JSON.parse(JSON.stringify(newVal))
})

const toggleSortDirection = (field: string): void => {
  if (selectedSortField.value === field) {
    if (sortDirectionMap[field] != 'desc') {
      sortDirectionMap[field] = sortDirectionMap[field] === 'asc' ? 'desc' : 'asc'
    } else {
      selectedSortField.value = '';
    }
  } else {
    selectedSortField.value = field
    sortDirectionMap[field] = 'asc'
  }
}

const getSortIcon = (field: string): string => {
  return sortDirectionMap[field] === 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down'
}

function applyFilters() {
  sortBy.value[0].key = selectedSortField.value;
  sortBy.value[0].order = sortDirectionMap[selectedSortField.value];
  if (localModel.value != undefined) {
    Object.assign(model.value, localModel.value);
  }
  props.onClose?.();
  props.fetch?.();
}

</script>